import Helper from './Helper';

class Header {
  constructor(config = {}) {

    this.body = document.querySelector('body');

    this.mobileServiceNavToggler = document.querySelector('#js-service-nav-mobile-toggle');
    this.mobileServiceNav = document.querySelector('.service-nav-mobile .js-service-nav');

    this.reportsNavToggler = document.querySelector('#js-reports-dropdown-toggle');
    this.reportsNav = document.querySelector('.header__top-reports .js-service-nav');
    this.reportsBackground = document.querySelector('.reports-backdrop');

    const menuItemLvl0NodeList = document.querySelectorAll('.menu__item--has-children > .menu__link--level-0');
    this.menuItemLvl0 = Array.prototype.slice.call(menuItemLvl0NodeList);

    const searchTogglersNodeList = document.querySelectorAll('.js-search-toggler');
    this.searchTogglers = Array.prototype.slice.call(searchTogglersNodeList);
    this.searchDropdown = document.querySelector('.header__search');
    this.searchInput = document.querySelector('.header__search .form__input--search');

    this.mobileMenu = document.querySelector('.header__bottom');
    this.mobileInner = document.querySelector('.header__inner--bottom');
    this.mobileSubMenu = document.querySelector('.mobile-sub-menu');

    this.mobileBackToggler = document.querySelector('#js-mobile-menu-back-toggler');
    this.mobileBackTitle = document.querySelector('#js-mobile-menu-back-title');

    this.headerDropdown = document.querySelector('#js-menu-dropdown');
    this.headerDropdownLvl1 = document.querySelector('#js-header-dropdown-level-1');
    this.headerDropdownLvl2 = document.querySelector('#js-header-dropdown-level-2');

    this.dropdownArticle = document.querySelector('#js-menu-dropdown-article');
    this.dropdownArticleTitle = document.querySelector('#js-menu-dropdown-article-title');
    this.dropdownArticleButton = document.querySelector('#js-menu-dropdown-article-button');

    this.burger = document.querySelector('#js-mobile-menu-toggler');

    this.backDrop = document.querySelector('.menu-backdrop');

    this.lastClick = false;

    this.bindEvents();

  }

  bindEvents(){
    // Mobile: Servicenav
    if(!!this.mobileServiceNavToggler){
      this.mobileServiceNavToggler.addEventListener('click', (e) => {
        e.preventDefault();
        Helper.slideToggle(this.mobileServiceNav);
        Helper.toggleClass(this.mobileServiceNavToggler, 'active');
      });
    }
    // Desktop: Servicenav
    if(!!this.reportsNavToggler){
      this.reportsNavToggler.addEventListener('click', (e) => {
        this.resetMenu();
        this.resetSearch();
        e.preventDefault();
        Helper.slideToggle(this.reportsNav);
        Helper.toggleClass(this.reportsNavToggler, 'active');
        Helper.toggleClass(this.reportsBackground, 'active');
      });
    }

    // Burger
    if(!!this.burger){
      this.burger.addEventListener('click', () => {
        if(this.burger.classList.contains('active')){
          Helper.slideUp(this.mobileMenu);
          this.burger.classList.remove('active');
          if(this.body.classList.contains('menu-open')) this.body.classList.remove('menu-open');
        } else{
          Helper.slideDown(this.mobileMenu);
          this.resetSearch();
          this.burger.classList.add('active');
          if(!this.body.classList.contains('menu-open')) this.body.classList.add('menu-open');
        }
      });
    }

    // Main Menu
    if(!!this.menuItemLvl0){
      this.menuItemLvl0.forEach(item => { item.addEventListener('click', (e) => {
          this.resetReports();
          e.preventDefault();
          const menu = item.parentNode.querySelector('.menu--level-1');
          const title = item.innerText;
          if(Helper.isDesktop()){
            const lastActive = document.querySelector('.menu__item--has-children > .menu__link--level-0.active');
            if(!!lastActive) lastActive.classList.remove('active');
            this.handleMenu(menu, item, item.dataset.id);
          } else{
            this.mobileInner.classList.add('moved');
            this.mobileSubMenu.innerHTML = menu.innerHTML;
            this.mobileBackTitle.innerHTML = title;

          }
          this.bindSubMenuEvents();
        });
      });
    }

    // Main Menu Back Button
    if(!!this.mobileBackToggler){
      this.mobileBackToggler.addEventListener('click', e => {
        this.mobileInner.classList.remove('moved');
        setTimeout(() => {
          this.mobileBackTitle.innerHTML = "";
          this.mobileSubMenu.innerHTML = "";
        }, 300);
      });
    }


    // Search triggers
    this.searchTogglers.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        if(button.classList.contains('active')){
          button.classList.remove('active')
          Helper.slideUp(this.searchDropdown);
          if(this.body.classList.contains('menu-open')){
            this.body.classList.remove('menu-open');
          }
        } else{
          this.resetMenu();
          button.classList.add('active')
          setTimeout(() => { this.searchInput.focus() }, 200);
          Helper.slideDown(this.searchDropdown);

          if(!this.body.classList.contains('menu-open')){
            this.body.classList.add('menu-open');
          }
        }
      });
    });

    // Backdrop
    if(!!this.backDrop){
      this.backDrop.addEventListener('click', () => {
        this.resetMenu();
        this.resetSearch();
      });
    }
    if(!!this.reportsBackground){
      this.reportsBackground.addEventListener('click', () => {
        this.resetReports();
      });
    }
  }

  resetReports(){
    if(this.reportsNavToggler.classList.contains('active')){
      Helper.slideToggle(this.reportsNav);
      Helper.toggleClass(this.reportsNavToggler, 'active');
      Helper.toggleClass(this.reportsBackground, 'active');
    }
  }

  resetSearch(){
    const searchToggler = document.querySelector('.js-search-toggler.active');
    if(!!searchToggler && searchToggler.classList.contains('active')){
      searchToggler.classList.remove('active')
      Helper.slideUp(this.searchDropdown);
    }
  }

  resetMenu(){
    if(!!this.headerDropdownLvl2 && this.headerDropdownLvl2.classList.contains('active')){
      this.headerDropdownLvl2.classList.remove('active');
    }
    if(!!this.headerDropdownLvl2) this.headerDropdownLvl2.innerHTML = "";
    if(!!this.headerDropdownLvl1) this.headerDropdownLvl1.innerHTML = "";
    if(this.body.classList.contains('menu-open')){
      this.body.classList.remove('menu-open');
      Helper.slideUp(this.headerDropdown);
      const lastActive = document.querySelector('.menu__item--has-children > .menu__link--level-0.active');
      if(!!lastActive) lastActive.classList.remove('active');
      const burger = document.querySelector('#js-mobile-menu-toggler.active');
      if(!!burger) burger.classList.remove('active');
      if(!Helper.isDesktop()){
        Helper.slideUp(this.mobileMenu);
      }
    }
  }

  /**
   * Sub Menu Links
   */
  bindSubMenuEvents(){
    if(Helper.isDesktop()){
      const subMenuLinksNodeList = document.querySelectorAll('.menu-dropdown .menu__item--has-children > .menu__link--level-1');
      const subMenuLinks = Array.prototype.slice.call(subMenuLinksNodeList);
      subMenuLinks.forEach(link => {
        link.addEventListener('click', e => {
          e.preventDefault();
          const lastActive = document.querySelector('.menu-dropdown .menu__item--has-children > .menu__link--level-1.active');
          if(!!lastActive) lastActive.classList.remove('active');
          link.classList.add('active');
          const menu = link.parentNode.querySelector('.menu--level-2');
          this.headerDropdownLvl2.innerHTML = menu.innerHTML;
          this.headerDropdownLvl2.classList.add('active');
          if(!!link.dataset.hashed || !!link.parentNode.dataset.hashed){
            const subLinksNodeList = document.querySelectorAll('.menu-dropdown__level--2 .menu__link--level-2');
            const subLinks = Array.prototype.slice.call(subLinksNodeList);
            let i = 0;
            subLinks.forEach(subLink => {
              subLink.href = link.href + '#' + i;
              subLink.addEventListener('click', () => {
                this.resetMenu();
              });
              i++;
            });
          }
        });
      });

    } else {
      const subMenuLinksNodeList = document.querySelectorAll('.mobile-sub-menu .menu__item--has-children > .menu__link--level-1');
      const subMenuLinks = Array.prototype.slice.call(subMenuLinksNodeList);
      subMenuLinks.forEach(link => {
        link.addEventListener('click', e => {
          e.preventDefault();
          const li = link.parentNode;
          if(li.classList.contains('active')){
            li.classList.remove('active');
            Helper.slideUp(li.querySelector('.menu--level-2'));
          } else {
            li.classList.add('active');
            Helper.slideDown(li.querySelector('.menu--level-2'));
            if(!!link.dataset.hashed || !!link.parentNode.dataset.hashed){
              const subLinksNodeList = link.parentNode.querySelectorAll('.menu__link--level-2');
              const subLinks = Array.prototype.slice.call(subLinksNodeList);
              let i = 0;
              subLinks.forEach(subLink => {
                subLink.addEventListener('click', () => {
                  this.resetMenu();
                });
                subLink.href = link.href + '#' + i;
                i++;
              });
            }
          }
        });
      });
    }
  }

  handleMenu(menu, item, id){

    if(this.body.classList.contains('menu-open') && this.lastClick == id){
      Helper.slideUp(this.headerDropdown, 300);
      this.body.classList.remove('menu-open');
      setTimeout(() => { this.headerDropdownLvl2.classList.remove('active') }, 300);
    } else{
      item.classList.add('active');
      this.headerDropdownLvl1.innerHTML = menu.innerHTML;
      this.headerDropdownLvl2.classList.remove('active')
      this.bindSubMenuEvents();
      this.setTeaser(item);

      if(!this.body.classList.contains('menu-open')){
        this.resetSearch();
        this.body.classList.add('menu-open');
        Helper.slideDown(this.headerDropdown, 300, true);
      }

    }

    this.lastClick = id;
  }

  setTeaser(item){
    if(!!item.dataset.title){
      this.dropdownArticle.style.backgroundImage = 'url('+item.dataset.img+')';
      this.dropdownArticleTitle.innerHTML = item.dataset.title;
      this.dropdownArticleButton.href = item.dataset.url;
      if(this.dropdownArticle.classList.contains('hidden')){
        this.dropdownArticle.classList.remove('hidden');
      }
    } else{
      if(!this.dropdownArticle.classList.contains('hidden')){
        this.dropdownArticle.classList.add('hidden');
        this.dropdownArticle.style.backgroundImage = 'none';
      }
    }
  }



} export default Header;


//const parent = Helper.getParentNodeWithClass(link, 'menu__item--level-1');

